module.exports = __webpack_public_path__ + "static/media/external-link.fc862d75.svg";